import React, { Component } from 'react'
import { connect } from 'react-redux'
import EventEmitter from 'events'

import CampaignOverviewForm from '../containers/CampaignOverviewForm'
import CampaignNavigationOptions from './CampaignNavigationOptions'
import { LoadingScreen } from '../components/commom'

const emitter = new EventEmitter()

class CampaignOverviewPage extends Component {
  tabChangeEventeEmitter() {
    emitter.emit('CampaignOverviewForm', {})
  }

  render() {
    const { currentUser, match } = this.props

    if (!currentUser.authenticated) return <LoadingScreen />

    return (
      <div className='container-fluid'>
        <div className='row'>
          <div className='col s12 m3'>
            <CampaignNavigationOptions match={match} onTabChange={this.tabChangeEventeEmitter} />
          </div>
          <div className='col s12 m9'>
            <CampaignOverviewForm match={match} tabChanged={emitter} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ currentUser }) => ({ currentUser })

export default connect(mapStateToProps)(CampaignOverviewPage)
